import styled from 'styled-components';

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const EventSection = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  gap: 20px;
  padding: 20px 24px;
  height: auto;
  width: 100%;
  & > * > p {
    margin: 0;
  }
`;

export const SecondaryTitle = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  font-style: normal;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SecondaryTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  justify-content: space-between;
`;

export const EmojiWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding: 4px;
`;

export const DocumentDisplayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const VideoPreviewContainer = styled.div`
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;

  media-player {
    width: 100%;
    height: 100%;
    display: block;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: 300px;
    max-width: 300px;
  }
`;
